<template>
  <div class="page container tesla-vehicle-container">
    <div v-if="getVehicle && Object.keys(getVehicle).length > 0 && !isLoader">
      <div v-if="Object.keys(getVehicle.drive_state).length > 0">
        <div class="container mt-4">
          <div v-if="auction && auction.viewType != 'raw'">
            <h2 class="text-center mb-4">Tesla Vehicle Detial</h2>

            <div class="row">
              <!-- Vehicle Info -->
              <div class="col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <h5 class="card-title">Vehicle Info</h5>
                    <p>
                      <strong>Name/Type:</strong>
                      {{
                        getVehicle.vehicle_name ||
                          getVehicle.vehicle_config.car_type
                      }}
                    </p>
                    <p><strong>VIN:</strong> {{ getVehicle.vin }}</p>
                    <p>
                      <strong>Model:</strong>
                      {{ getVehicle.vehicle_config.car_type.toUpperCase() }}
                    </p>
                    <p>
                      <strong>Color:</strong>
                      {{ getVehicle.vehicle_config.exterior_color }}
                    </p>
                    <p>
                      <strong>Odometer:</strong>
                      {{ getVehicle.vehicle_state.odometer }} miles
                    </p>
                    <p>
                      <strong>State:</strong>
                      <span :class="getStatusClass(getVehicle.state)">{{
                        getVehicle.state
                      }}</span>
                    </p>
                  </div>
                </div>
              </div>

              <!-- Battery & Charging Info -->
              <div class="col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <h5 class="card-title">Battery & Charging</h5>
                    <p>
                      <strong>Battery Level:</strong>
                      {{ getVehicle.charge_state.battery_level }}%
                    </p>
                    <p>
                      <strong>Estimated Range:</strong>
                      {{ getVehicle.charge_state.battery_range }} miles
                    </p>
                    <p>
                      <strong>Charging State:</strong>
                      {{ getVehicle.charge_state.charging_state }}
                    </p>
                    <p>
                      <strong>Supercharger Connected:</strong>
                      {{
                        getVehicle.charge_state.fast_charger_present
                          ? "Yes"
                          : "No"
                      }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <!-- Climate Info -->
              <div class="col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <h5 class="card-title">Climate & Temperature</h5>
                    <p>
                      <strong>Inside Temperature:</strong>
                      {{ getVehicle.climate_state.inside_temp }}°C
                    </p>
                    <p>
                      <strong>Outside Temperature:</strong>
                      {{ getVehicle.climate_state.outside_temp }}°C
                    </p>
                    <p>
                      <strong>Cabin Overheat Protection:</strong>
                      {{ getVehicle.climate_state.cabin_overheat_protection }}
                    </p>
                    <p>
                      <strong>HVAC Auto Request:</strong>
                      {{ getVehicle.climate_state.hvac_auto_request }}
                    </p>
                  </div>
                </div>
              </div>

              <!-- Drive State -->
              <div class="col-md-6">
                <div class="card mb-3">
                  <div class="card-body">
                    <h5 class="card-title">Drive State</h5>
                    <p>
                      <strong>Location:</strong>
                      {{ getVehicle.drive_state.latitude }},
                      {{ getVehicle.drive_state.longitude }}
                    </p>
                    <p>
                      <strong>Heading:</strong>
                      {{ getVehicle.drive_state.heading }}°
                    </p>
                    <p>
                      <strong>Speed:</strong>
                      {{ getVehicle.drive_state.speed || "N/A (Parked)" }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-else> 
            <h2>Tesla Vehicle Raw Data</h2>
            <div style="height: 400px; overflow-x: auto;"> 
              
              <pre>{{ JSON.stringify(getVehicle, null, 2) }}</pre>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isLoader">
      <LoaderComponent />
    </div>
  </div>
</template>
<script>
import {
  createAuctionManagerMixin,
  auctionManagerStore
} from "@/mixins/auctionsManagerMixin";
import LoaderComponent from "./LoaderComponent";
export default {
  name: "ViewTeslaVehicleComponent",
  mixins: [createAuctionManagerMixin()],
  components: { LoaderComponent },
  props: {
    auction: {
      type: Object
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isLoader: true
    };
  },
  created() {},
  watch: {
    auction(v) {
      console.log("auction v", v);
      this.getDateById();
    }
  },
  computed: {
    getVehicle() {
      console.log(
        "this[auctionManagerStore.getterTypes.GETTER_TESLA_AUCTION]",
        this[auctionManagerStore.getterTypes.GETTER_TESLA_AUCTION]
      );
      return this[auctionManagerStore.getterTypes.GETTER_TESLA_AUCTION];
    }
  },
  methods: {
    getStatusClass(status) {
      return status === "online" ? "text-success" : "text-danger";
    },
    async getDateById() {
      try {
        console.log("auction1234", this.auction);
        if (this.auction && this.auction.vin) {
          this.isLoader = true;
          await this[
            auctionManagerStore.actionTypes.ACTION_LOAD_TESLA_VEHICLE_BY_ID
          ]({
            id: this.auction.id
          });
          this.isLoader = false;
        }
      } catch (errorMessage) {
        this.isLoader = false;
        console.log(errorMessage);
      }
    }
  }
};
</script>
